// // src/app/Routes.jsx
// import React from "react";
// import { useLocation, Navigate, Routes as RNRoutes, Route } from "react-router-dom";
// import { Layout } from "../_metronic/layout";
// import BasePage from "./BasePage";
// import { Logout, AuthPage } from "./modules/Auth";
// import ErrorsPage from "./modules/ErrorsExamples/ErrorsPage";
// import { useSelector, shallowEqual } from 'react-redux';
// import QRCodeView from "./modules/Auth/pages/QRCodeView";

// export function Routes() {
//   const location = useLocation();
//   const { isAuthorized } = useSelector(
//     ({ auth }) => ({
//       isAuthorized: auth.user && auth.organization != null,
//     }),
//     shallowEqual
//   );

//   return (
//     <RNRoutes>
//       {/* Public - QR code view */}
//       <Route path="/qr/:code" element={<QRCodeView />} />

//       {/* Auth - redirect to / if already logged in */}
//       <Route
//         path="/auth/*"
//         element={!isAuthorized ? <AuthPage /> : <Navigate to="/" replace />}
//       />

//       {/* Error pages - must be /* so /error/error-v1 matches */}
//       <Route path="/error/*" element={<ErrorsPage />} />

//       {/* Logout */}
//       <Route path="/logout" element={<Logout />} />

//       {/* Protected routes */}
//       <Route
//         path="/*"
//         element={
//           isAuthorized ? (
//             <Layout>
//               <BasePage />
//             </Layout>
//           ) : (
//             <Navigate to="/auth/login" state={{ from: location }} replace />
//           )
//         }
//       />
//     </RNRoutes>
//   );
// }



// src/app/Routes.jsx
import React from "react";
import { useLocation, Navigate, Routes as RNRoutes, Route } from "react-router-dom";
import { Layout } from "../_metronic/layout";
import BasePage from "./BasePage";
import { Logout, AuthPage } from "./modules/Auth";
import ErrorsPage from "./modules/ErrorsExamples/ErrorsPage";
import SubscriptionBlockedPage from "./modules/Settings/pages/SubscriptionBlockedPage";
import { useSelector, shallowEqual } from 'react-redux';
import QRCodeView from "./modules/Auth/pages/QRCodeView";

export function Routes() {
  const location = useLocation();
  const { isAuthorized } = useSelector(
    ({ auth }) => ({
      isAuthorized: auth.user && auth.organization != null,
    }),
    shallowEqual
  );

  return (
    <RNRoutes>
      {/* Public - QR code view */}
      <Route path="/qr/:code" element={<QRCodeView />} />

      {/* Auth - redirect to / if already logged in */}
      <Route
        path="/auth/*"
        element={!isAuthorized ? <AuthPage /> : <Navigate to="/" replace />}
      />

      {/* Error pages */}
      <Route path="/error/*" element={<ErrorsPage />} />

      {/* Logout */}
      <Route path="/logout" element={<Logout />} />

      {/* Subscription blocked — accessible even when suspended/cancelled.
          Renders for both authed and unauthed states so the user can still
          see the page and navigate to billing or logout. */}
      <Route path="/subscription-blocked" element={<SubscriptionBlockedPage />} />

      {/* Protected routes */}
      <Route
        path="/*"
        element={
          isAuthorized ? (
            <Layout>
              <BasePage />
            </Layout>
          ) : (
            <Navigate to="/auth/login" state={{ from: location }} replace />
          )
        }
      />
    </RNRoutes>
  );
}